<template>
<div id="o-base-app" data-component="BaseApp.vue" :data-is-virtual-keyboard-visible="isVirtualKeyboardVisible">
	<div
		v-if="isScreenDimmed"
		class="is-dimmed | md:g-black/25 md:fixed md:inset-0 md:z-[4096] md:backdrop-blur-sm"
		@click="isScreenDimmed = false"
	/>

	<router-view v-if="$route.meta.noDecorate"/>
	<AppRouterView v-else-if="appModule === 'RouterView'"/>
	<component :is="appModule" v-else-if="appModule" ref="CurrentModule"/>

	<div
		id="preload-placeholder"
		class="fixed inset-0 z-[4096] flex items-center justify-center bg-white/75 transition-opacity duration-300"
		:class="isSavingScreenVisible ? 'opacity-100 pointer-events-all delay-150' : 'opacity-0 pointer-events-none'"
	>
		<Loader/>
	</div>

	<WebsocketsElement v-if="websocketUrl" ref="Websockets"/>
	<ToasterElement ref="Toaster"/>

	<div
		v-if="loggedAs"
		class="fixed bottom-0 left-0 z-64 m-2 !block bg-warn p-2 text-black"
		v-html="`Zalogowany jako <strong>${loggedAs}</strong>`"
	/>
</div>
</template>

<script lang="ts">
import { mapActions, mapStores, mapWritableState, mapState } from 'pinia';
import { defineAsyncComponent } from 'vue';
import { ToasterElement } from 'ofe-common/components';

import AppRouterView from '@globals/AppRouterView.vue'; /** globals */
import WebsocketsElement from '@globals/components/global/WebsocketsElement.vue';
import Formatters from '@globals/Formatters';
import hello from '@globals/Hello';
import PushNotifications from '@globals/PushNotifications';
import StateManager from '@globals/StateManager';
import { useAppStore } from '@globals/stores/app';
import { useUserStore } from '@globals/stores/user';
import Validators from '@globals/Validators';


export default {
	name: 'BaseApp',
	components: {
		AppRouterView,
		ToasterElement,
		WebsocketsElement,
		PublicView: defineAsyncComponent(() => import('./PublicView.vue')),
	},
	data() {
		return {
			StateManager: null as null | StateManager,
			Formatters: new Formatters(),
			Validators,
			Push: null as null | PushNotifications,
			IsLoading: true,
		};
	},
	computed: {
		...mapWritableState(useAppStore, { appModule: 'module' }),
		...mapWritableState(useUserStore, ['loggedAs', 'role']),
		...mapWritableState(useAppStore, [
			'websocketUrl',
			'isVirtualKeyboardVisible',
			'isScreenDimmed',
			'isSavingScreenVisible',
			'pathname',
		]),
		...mapState(useUserStore, ['customerId', 'userId']),
		...mapStores(useAppStore),
	},
	async created() {
		console.log('Oferteo.pl / app-public/PublicApp.vue');

		document.documentElement.classList.add('theme-customer');
		await this.hello();

		this.pathname = window.location.pathname;
	},
	methods: {
		...mapActions(useAppStore, [
			'sendStartupAnalytics',
			'mobileAppRoutine',
		]),

		async hello() {
			await hello(false);

			this.mobileAppRoutine();
			this.sendStartupAnalytics();

			this.appModule = 'PublicView';
			this.IsLoading = false;
			this.isSavingScreenVisible = false;
		},
	},
};
</script>
